import { FulltextEnvService } from '@aipb/gulliver/fulltext/env';
import { BaseRouting } from '@aipb/gulliver/routing';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FulltextRouting extends BaseRouting {
  static APP_ROUTE = 'fulltext';
  static editionPath = 'edition';
  static editionDefaultPath = ':editId/:fragPos';
  static configPath = ':configId';

  static settingsPath = 'settings';
  static settingsDefaultPath = '';

  private _editionDefault: string[] = [FulltextRouting.editionPath, FulltextRouting.editionDefaultPath];

  private _settingsDefault: string[] = [FulltextRouting.settingsPath];

  constructor(fulltextEnv: FulltextEnvService) {
    super(['/' + FulltextRouting.APP_ROUTE, FulltextRouting.configPath], fulltextEnv);
  }

  public editionDefault(editId: number, fragPos: number, configId: string = this.getConfigId()): void {
    this.nav(this._editionDefault, {
      editId,
      fragPos,
      configId
    });
  }

  public editionDefaultAbsUrl(editId: number, fragPos: number, configId: string = this.getConfigId()): string {
    return this.absUrl(this._editionDefault, {
      editId,
      fragPos,
      configId
    });
  }

  public editionDefaultRouteUrl(editId: number, fragPos: number, configId: string = this.getConfigId()): string {
    return this.routeUrl(this._editionDefault, {
      editId,
      fragPos,
      configId
    });
  }

  public settingsDefault(configId: string = this.getConfigId()): void {
    this.nav(this._settingsDefault, {
      configId
    });
  }

  public settingsDefaultRouteUrl(configId: string = this.getConfigId()): string {
    return this.routeUrl(this._settingsDefault, {
      configId
    });
  }
}
